import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { type CallContact } from 'entities/Call/model/CallContact'

type IEndResumeActionsProps = {
  item: CallContact
  onResume: (item: CallContact) => void
  onEnd: (item: CallContact) => void
  resumeDisabled?: boolean
  innerRefCurrent?: HTMLDivElement
}

export const EndResumeActions: FC<IEndResumeActionsProps> = observer(
  ({ item, onResume, onEnd, resumeDisabled = false, innerRefCurrent }) => (
    <>
      <IconButton
        ariaLabel={'ContactCardResume'}
        icon={'play1'}
        size={'small'}
        color={'blue'}
        variant={'custom'}
        active
        disabled={resumeDisabled}
        fontSize={16}
        tooltipProps={{
          label: 'Resume',
          placement: 'top',
          zIndex: ZIndex.OVERLAY_TOP_1,
          PopperProps: {
            popperOptions: {
              modifiers: [{ name: 'preventOverflow', options: { boundary: innerRefCurrent } }],
            },
          },
        }}
        onClick={() => onResume(item)}
      />
      <IconButton
        ariaLabel={'ContactCardEnd'}
        icon={'phoneHangUp'}
        size={'small'}
        color={'red'}
        fontSize={16}
        tooltipProps={{
          label: 'End call',
          placement: 'top',
          zIndex: ZIndex.OVERLAY_TOP_1,
          PopperProps: {
            popperOptions: {
              modifiers: [{ name: 'preventOverflow', options: { boundary: innerRefCurrent } }],
            },
          },
        }}
        onClick={() => onEnd(item)}
      />
    </>
  )
)
